// src/sections/Section4.jsx
import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Left_title = ({ contenuti }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Normalizza in array
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  // Gestione breakpoint
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {contenutiArray.map((content, index) => {
        // Destrutturazione con rinomina dai campi JSON
        const {
          titolo_1: titolo1,
          titolo_2: titolo2,
          sottotitolo_it: sottotitolo,
          descrizione_it: descrizione,
          immagini_aggiuntive: immaginiAggiuntive = [],
          call_to_action_it: callToAction,
          link_it: link,
        } = content;

        return (
          <div
            key={index}
            className="container-fluid d-flex flex-column justify-content-start position-relative"
            style={{ padding: "32px 16px", gap: "16px" }}
          >
            <div className="container">
              <div className="row w-100">
                {/* Colonna sinistra: titolo */}
                <div className="col-12 col-md-7 d-flex flex-column align-items-start">
                  {sottotitolo && (
                    <p className="mini-title">{sottotitolo}</p>
                  )}
                  <div className="title-section">
                    <span
                      className={`black-text ${
                        isMobile
                          ? "d-block d-lg-none title-section-mobile"
                          : "d-none d-lg-block title-section"
                      }`}
                    >
                      {titolo1}
                    </span>
                    <span
                      className={`green-text ${
                        isMobile
                          ? "d-block d-lg-none title-section-mobile"
                          : "d-none d-lg-block title-section"
                      }`}
                    >
                      {titolo2}
                    </span>
                  </div>
                </div>

                {/* Colonna destra: descrizione + bottone */}
                <div className="col-12 col-md-5 d-flex flex-column align-items-start gap-3 mt-3 mt-md-0 bold">
                  {descrizione && (
                    <p
                      className="custom-text semi-bold"
                      dangerouslySetInnerHTML={{ __html: descrizione }}
                    />
                  )}
                  {callToAction && (
                    <CarButton
                      text={callToAction}
                      to={link || "#"}
                      customClass="btn btn-three"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Immagini aggiuntive, se presenti */}
            {immaginiAggiuntive.length > 0 && (
              <div className="container py-3">
                <div className="row">
                  {immaginiAggiuntive.map((img, idx) => (
                    <div
                      key={idx}
                      className="col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0"
                    >
                      <img
                        src={img.immagine_path}
                        alt={img.descrizione || `Image ${idx + 1}`}
                        className="img-fluid"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Left_title;
